export enum ERefsLeftMenu {
	GAMES = 'moblmnu',
	GAMES_PROMO = 'mobleft_promo',
	GAMES_HIT = 'moblmnu_hit',
}
